export default __webpack_public_path__ + "static/media/elmo.7bf90dd3.svg";